import { render } from "./ArchiveDashboard.vue?vue&type=template&id=5ec98868&scoped=true"
import script from "./ArchiveDashboard.vue?vue&type=script&lang=js"
export * from "./ArchiveDashboard.vue?vue&type=script&lang=js"

import "./ArchiveDashboard.vue?vue&type=style&index=0&id=5ec98868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec98868"]])

export default __exports__